<template>
  <div
    class="report-rollup"
    :class="{ 'report-rollup-loading': showLoading }"
  >
    <ul class="report-rollup-data">
      <li
        v-for="(data, index) in rollupData"
        :key="`${data.label}-${index}`"
        :class="{ 'report-rollup-data-blank': !data.value }"
      >
        <div class="report-rollup-label">{{ data.label }}</div>
        <div class="report-rollup-value">{{ displayValue(data) }}</div>
      </li>
    </ul>
    <a
      v-if="showChartToggle && !showLoading"
      class="report-rollup-chart-toggle"
      :class="{ active: chartEnabled }"
      @click="toggleChart"
    >
      <i class="hi hi-activity hi-16"></i>
    </a>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

/***
 * Usage
 *
 * Provide an array via the rollupData prop containg objects with the following properties.
 *
 * *label* (required): The label for the rollup item
 * *value* (required): The raw value for the rollup item -- this is used to determine if the item is "blank"
 * *displayValue* (optional): A rollup item value more suitable for display
 * *blank* (optional): What to display if an item is "blank" (defaults to "-")
 */
export default {
  props: {
    rollupData: {
      type: Array,
      required: true,
    },
    showChartToggle: {
      type: Boolean,
      default: false,
    },
    chartEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['showLoading']),
  },
  methods: {
    ...mapActions(['analyticsTrackReport']),
    displayValue(data) {
      if (data.value) {
        return data.displayValue || data.value;
      }

      return data.blank || '—';
    },
    toggleChart() {
      this.$emit('toggle-chart');

      this.analyticsTrackReport({
        event: 'Report view graph',
        props: {
          view_graph_value: !this.chartEnabled,
        },
      });
    },
  },
};
</script>
